(() => {
 const cartAction = document.querySelector('[data-sh-cart-action]');
 if (cartAction) {
  const countNode = cartAction.querySelector('[data-sh-cart-count]');
  const labelNode = cartAction.querySelector('[data-sh-cart-label]');
  const renderCart = () => {
   const hasItems = Number(countNode.textContent) > 0;
   labelNode.textContent = hasItems ? cartAction.dataset.cartLabel : cartAction.dataset.startLabel;
   cartAction.href = hasItems ? cartAction.dataset.cartUrl : cartAction.dataset.startUrl;
   countNode.hidden = !hasItems;
  };
  new MutationObserver(renderCart).observe(countNode,{childList:true,characterData:true,subtree:true});
  const refreshCart = async () => {
   try {
    const response = await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    if (Number.isInteger(cart.item_count)) countNode.textContent = cart.item_count;
   } catch (_) {}
  };
  window.addEventListener('pageshow',refreshCart);
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')refreshCart();});
  renderCart();
 }
 const initialize = root => {
  if (!root || root.dataset.shReady || !root.querySelector('.sh-nav')) return;
  root.dataset.shReady = 'true';
  const menuButtons = [...root.querySelectorAll('[data-sh-menu]')];
  const menuPanels = [...root.querySelectorAll('[data-sh-panel]')];
  const menuWrap = root.querySelector('.sh-mega-wrap');
  const nav = root.querySelector('.sh-nav');
  const mobileViewport = matchMedia('(max-width:749px)');
  const navHost = nav.parentElement;
  let navOrigin = 0;
  let scrollFrame = 0;
  let viewportWidth = innerWidth;
  let motions = [];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const parts = [...nav.querySelectorAll('.sh-logo,.sh-home-cart,.sh-home-menu-toggle')];
  const cancelMotion = () => { motions.forEach(m => m.cancel()); motions = []; };
  const updateScrollHeader = (animate = true) => {
   scrollFrame = 0;
   nav.style.setProperty('--sh-pin-top',Math.max(8,navOrigin-Math.max(0,scrollY))+'px');
   const wasFloating = root.classList.contains('sh-scrolled');
   const floating = scrollY > navOrigin-8 + (wasFloating ? -8 : 0);
   if (floating === wasFloating || root.classList.contains('sh-menu-open')) return;
   const before = parts.map(el => el.getBoundingClientRect());
   cancelMotion();
   root.classList.toggle('sh-scrolled',floating);
   if (animate && !reducedMotion.matches) {
    motions = parts.map((el,i) => {
     const end = el.getBoundingClientRect(), start = before[i];
     if (!end.width || !end.height) return null;
     return el.animate([
      {transform:`translate(${start.x-end.x}px,${start.y-end.y}px) scale(${start.width/end.width},${start.height/end.height})`,transformOrigin:'0 0'},
      {transform:'translate(0,0) scale(1)',transformOrigin:'0 0'}
     ],{duration:300,easing:'cubic-bezier(.22,1,.36,1)'});
    }).filter(Boolean);
   }
  };
  const measureScrollHeader = () => {
   if (root.classList.contains('sh-menu-open')) return;
   cancelMotion();
   root.classList.remove('sh-scrolled','sh-pinned');
   navHost.style.minHeight = '';
   {
    const rect = nav.getBoundingClientRect();
    navOrigin = rect.top+scrollY;
    if (getComputedStyle(nav).position !== 'absolute') navHost.style.minHeight = rect.height+'px';
    root.classList.add('sh-pinned');
   }
   updateScrollHeader(false);
  };
  window.addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(()=>updateScrollHeader());},{passive:true});
  window.addEventListener('resize',()=>{if(innerWidth!==viewportWidth){viewportWidth=innerWidth;measureScrollHeader();}});
  window.addEventListener('pageshow',measureScrollHeader);
  reducedMotion.addEventListener('change',cancelMotion);
  measureScrollHeader();

  const homeToggle = root.querySelector('.sh-home-menu-toggle');
  let homeOpened = false;
  let openName = null;
  let leaveTimer;
  let hoverOpened = false;
  let keyboardNavigation = false;
  document.addEventListener('keydown',event=>{if(event.key==='Tab'){keyboardNavigation=true;nav.dataset.shInput='keyboard';}});
  document.addEventListener('pointerdown',()=>{keyboardNavigation=false;nav.dataset.shInput='pointer';},true);
  const closeMenus = (restoreFocus = false) => {
   const trigger = menuButtons.find(button => button.dataset.shMenu === openName);
   menuPanels.forEach(panel => {panel.hidden = true;});
   menuButtons.forEach(button => button.setAttribute('aria-expanded', 'false'));
   menuWrap.removeAttribute('data-open');
   root.classList.remove('sh-menu-open');
   homeToggle?.setAttribute('aria-expanded','false');
   openName = null;
   if(restoreFocus) { if(homeOpened && homeToggle) homeToggle.focus(); else trigger?.focus(); }
   homeOpened=false;
   hoverOpened=false;
   clearTimeout(leaveTimer);
  };
  const openMenu = name => {
   cancelMotion();
   clearTimeout(leaveTimer);
   menuPanels.forEach(panel => {panel.hidden = panel.dataset.shPanel !== name;});
   menuButtons.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.shMenu === name)));
   menuWrap.setAttribute('data-open',name);
   root.classList.add('sh-menu-open');
   homeToggle?.setAttribute('aria-expanded','true');
   openName = name;
   menuPanels.find(panel => panel.dataset.shPanel === name)?.querySelectorAll('img').forEach(img => {img.loading='eager';});
  };
  homeToggle?.addEventListener('click',()=>{homeOpened=true;openMenu('shop');if(keyboardNavigation)menuButtons[0]?.focus();});
  root.querySelector('.sh-mobile-close')?.addEventListener('click',()=>closeMenus(true));
  matchMedia('(max-width:749px)').addEventListener('change',()=>closeMenus());
  menuPanels.forEach(panel=>panel.addEventListener('click',event=>{if(event.target.closest('a'))closeMenus();}));
  menuButtons.forEach((button,index) => {
   button.addEventListener('click', () => { if(openName === button.dataset.shMenu && !hoverOpened) closeMenus(); else openMenu(button.dataset.shMenu); hoverOpened=false; });
   button.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) {openMenu(button.dataset.shMenu);hoverOpened=true;}});
   button.addEventListener('keydown', event => {
    if(event.key === 'ArrowDown'){event.preventDefault();openMenu(button.dataset.shMenu);menuPanels.find(panel=>panel.dataset.shPanel===button.dataset.shMenu)?.querySelector('a')?.focus();}
    if(event.key === 'ArrowRight' || event.key === 'ArrowLeft'){event.preventDefault();menuButtons[(index+(event.key==='ArrowRight'?1:menuButtons.length-1))%menuButtons.length].focus();}
   });
  });
  nav.addEventListener('pointerleave', event => {if(event.pointerType==='mouse' && hoverOpened && !homeOpened) leaveTimer=setTimeout(()=>{if(hoverOpened && !homeOpened && !nav.contains(document.activeElement))closeMenus();},180);});
  nav.addEventListener('pointerenter', () => clearTimeout(leaveTimer));
  document.addEventListener('keydown', event => {if(event.key==='Escape'&&openName){event.preventDefault();closeMenus(true);}});
  nav.addEventListener('focusout', () => setTimeout(()=>{if(keyboardNavigation&&!nav.contains(document.activeElement))closeMenus();},0));
  document.addEventListener('pointerdown', event => {if(openName&&!nav.contains(event.target))closeMenus();});

  const track = root.querySelector('.sh-story-track');
  const previous = root.querySelector('[data-sh-prev]');
  const next = root.querySelector('[data-sh-next]');
  const status = root.querySelector('[data-sh-status]');
  if (!track) return;
  const cards = [...track.children];
  let current = 0;
  const update = () => {
   const center = track.getBoundingClientRect().left + track.clientWidth / 2;
   current = cards.reduce((closest, card, index) => {
    const a = card.getBoundingClientRect();
    const b = cards[closest].getBoundingClientRect();
    return Math.abs(a.left + a.width / 2 - center) < Math.abs(b.left + b.width / 2 - center) ? index : closest;
   }, 0);
   previous.disabled = current === 0;
   next.disabled = current === cards.length - 1;
   status.textContent = `${String(current + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
  };
  const move = direction => {
   const target = cards[Math.max(0, Math.min(cards.length - 1, current + direction))];
   const r = target.getBoundingClientRect();
   const t = track.getBoundingClientRect();
   track.scrollBy({left:r.left - t.left - (track.clientWidth - r.width) / 2, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, {passive:true});
  track.addEventListener('keydown', event => {
   if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
  });
  new ResizeObserver(update).observe(track);
  root.querySelector('.sh-menu')?.addEventListener('keydown', event => {if(event.key === 'Escape'){event.currentTarget.open=false;event.currentTarget.querySelector('summary').focus();}});
  update();
 };
 document.querySelectorAll('.sh-home').forEach(initialize);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sh-home').forEach(initialize));
})();













